<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
  >
    <div class="md-toolbar-row">
      <!-- <div class="md-toolbar-section-start"> -->
        <div class="md-collapse" style="justify-content: flex-start">

          <md-list style="padding-left:0;padding-right:0;">

            <li class="md-list-item"
              v-if="formConfig.pageMode !== 'view' && formConfig.pageMode !== 'assignee'"
            >
              <md-button
                slot="title"
                class="md-button md-just-icon md-simple"
                v-on:click="save"
                :disabled="isSaveButtonDisabled"
              >
                <md-icon>save</md-icon>
              </md-button>
            </li>

            <li class="md-list-item"
              v-if="formConfig.pageMode !== 'view' && formConfig.pageMode !== 'assignee'"
            >
              <md-button
                slot="title"
                class="md-button md-just-icon md-simple md-warning"
                v-on:click="cancel"
              >
                <md-icon style="color:red !important;">close</md-icon>
              </md-button>
            </li>

            <li class="md-list-item"
              v-if="formConfig.pageMode === 'view' || formConfig.pageMode === 'assignee'"
            >
              <md-button
                slot="title"
                class="md-button md-just-icon md-simple"
                :class="(formConfig.pageMode == 'view' || formConfig.pageMode == 'assignee')? 'md-warning' : 'md-success'"
                @click="formConfig.pageMode = 'edit'"
              >
                <md-icon>edit</md-icon>
              </md-button>
            </li>

            <li class="md-list-item" v-if="$Session.user">
              <a
                :href="'#' + $route.path"
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down" v-if="atShowAuditLog && 'view' == formConfig.pageMode">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>more_vert</md-icon>
                      <p class="hidden-lg hidden-md">More Options</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-left">
                      <li v-if="isAdmin && typeof atOpenMergeDialog == 'function'">
                        <a @click="openMergeDialog">
                          <md-icon>merge_type</md-icon> {{this.mergeText}}
                        </a>
                      </li>
                      <li v-if="atShowAuditLog">
                        <a @click="atShowAuditLog">
                          <md-icon>visibility</md-icon> Audit Log
                        </a>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

          </md-list>

          
        <SelectDynamicModel v-if="statusControlConfig && $route.params.id" :id="statusControlConfig.id" :config="statusControlConfig" :formConfig="formConfig" :recordData="recordData" style="margin-right: 15px"/>

        
        <AutocompleteDynamicModel v-if="assigneeControlConfig && $route.params.id" :id="assigneeControlConfig.id"
          :config="assigneeControlConfig"
          :form="form"
          :save="save"
          :formConfig="formConfig"
          :recordData="recordData"
          :field="assigneeControlConfig.field"
        />

        </div>
      <!-- </div> -->
      <!-- <div class="md-toolbar-section-end">

        
      </div> -->
    </div>
  </md-toolbar>
</template>

<script>
  import _ from "lodash";
  import SelectDynamicModel from '@/components/Crud/Inputs/SelectDynamicModel'
  import AutocompleteDynamicModel from '@/components/Crud/Inputs/AutocompleteDynamicModel'

  export default {
    name: "crud-toolbar",
    components: {
      SelectDynamicModel,
      AutocompleteDynamicModel
    },
    props: {
      statusControlConfig: {
        type: Object
      },
      assigneeControlConfig: {
        type: Object
      },
      cancel: {
        type: Function,
        required: true
      },
      save: {
        type: Function,
        required: true
      },
      formConfig: {
        type: Object,
        required: true
      },
      form: {
        type: Object,
        required: true
      },
      $v: {
        type: Object,
        required: true
      },
      btnActive: {
        type: Boolean
      },
      atShowAuditLog: {
        type: Function
      },
      atOpenMergeDialog: {
        type: Function
      },
      mergeText: {
        type: String
      },
      recordData: {
        type: Object,
      },
      isSaveInProgress: {
        type: Boolean
      }
    },
    data() {
      return {
        isAdmin: false
      }
    },
    watch: {
      '$Session.groups': {
        immediate: true,
        handler: function(){
          let findIndex = _.findIndex(this.$Session.groups, function(group) {
            return group.name == 'Admin';
          });
          this.isAdmin = (findIndex != -1) ? true : false;
        }
      },
      'recordData': {
        immediate: true,
        handler: function(newValue, oldValue){
          if(newValue && newValue != '' && newValue != oldValue){
            const status = this.recordData && this.recordData.status ? this.recordData.status.replace(/_/g, " ") : ''
            this.$set(this.statusControlConfig, 'defaultSelectedValue', status)                    
          }
        }
      }
    },
    methods: {
      openMergeDialog() {
        if(this.formConfig.openMergeDialog && 'function' == typeof this.formConfig.openMergeDialog){
          const body = document.querySelector('body');
          body.classList.add('isMergeDialogOpen');
          this.formConfig.openMergeDialog();
        }
      }
    },
    computed: {
      //ATLAS-447: Enable/Disable Save button
      isSaveButtonDisabled () {
        if (this.isSaveInProgress === true || this.formConfig.isSaveInProgress === true) {
          return true;
        }
        return this.btnActive ? (this.$v.form.$invalid) : (this.$v.form.$invalid || !this.$v.form.$anyDirty)
      }
    }
  };
</script>
<style>
body.isMergeDialogOpen {
  overflow-y: hidden;
}
.left-align {
  left: -80px !important;
}
</style>
